import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  type: 'software' | 'organization' | 'product' | 'article' | 'howto';
  data?: any;
}

export const StructuredData = ({ type, data }: StructuredDataProps) => {
  const getStructuredData = () => {
    switch (type) {
      case 'software':
        return {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "@id": "https://ugcvideoolusturucu.com.tr/#software",
          "name": "UGC Video Oluşturucu",
          "applicationCategory": "MultimediaApplication",
          "applicationSubCategory": "Video Production Software",
          "operatingSystem": "Web Browser",
          "description": "Tamamen Türkçe, çok-araçlı yapay zekâ reklam stüdyosu. Hem ticari (e-ticaret reklamı, ürün fotoğrafı) hem sosyal (kişisel video, konuşan fotoğraf, müzik) içerik: UGC video, sinema reklamı, sanal deneme, video dublaj ve 20'den fazla araç tek panelde, tamamen Türkçe. Ürün fotoğrafını yükle, reklamın dakikalar içinde hazır olsun.",
          "url": "https://ugcvideoolusturucu.com.tr",
          "offers": {
            "@type": "AggregateOffer",
            "priceCurrency": "TRY",
            "lowPrice": "0",
            "highPrice": "2499",
            "offerCount": "4",
            "availability": "https://schema.org/InStock"
          },
          "featureList": [
            "UGC reklam videosu (10 farklı stil, Türkçe konuşan avatar)",
            "Sinema reklamı (sinematik ürün reklam filmi)",
            "Ürün fotoğrafı (AI stüdyo kalitesinde + yazı)",
            "Ürün görsel seti (çoklu açı + arka plan)",
            "Sanal deneme / try-on (ürünü modelin üstünde gösterme)",
            "Konuşan fotoğraf (Türkçe dudak senkronu)",
            "Video dublaj (başka dile dudak senkronlu çeviri)",
            "Yüz değiştirme",
            "Hareket taklidi (referans videodaki hareketi kopyalama)",
            "Video klonlama (kişiyi avatara dönüştürme)",
            "Dönüşüm videosu (öncesi-sonrası)",
            "Ürün 360° tanıtım videosu",
            "Görsel canlandırma + 20 kamera/efekt preset'i",
            "Kalite yükseltici (Topaz ile netleştirme+büyütme)",
            "Kampanya afişi (Türkçe yazılı indirim afişi)",
            "Bağlantıdan reklam (ürün linkinden otomatik üretim)",
            "Reklam müziği ve sözlü marka jingle'ı",
            "Videoyu kliple (uzun videodan otomatik shorts)",
            "TikTok & Instagram Reels 9:16 dikey format",
            "E-ticaret entegrasyonu (Trendyol, Hepsiburada)",
            "Parçalara ayırma / exploded view (viral ürün görseli+videosu)",
            "Sohbetle görsel (doğal Türkçe konuşarak üret ve düzelt, prompt gerekmez)"
          ],
          "screenshot": "https://ugcvideoolusturucu.com.tr/logo.png",
          "softwareVersion": "3.0",
          "datePublished": "2024-01-01",
          "dateModified": "2026-07-14",
          "inLanguage": "tr",
          "availableLanguage": ["tr"],
          "provider": {
            "@id": "https://ugcvideoolusturucu.com.tr/#organization"
          }
        };
      
      case 'organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "@id": "https://ugcvideoolusturucu.com.tr/#organization",
          "name": "UGC Video Oluşturucu",
          "alternateName": ["UGC Studio", "UGC Video TR"],
          "url": "https://ugcvideoolusturucu.com.tr",
          "logo": {
            "@type": "ImageObject",
            "url": "https://ugcvideoolusturucu.com.tr/logo.png",
            "width": 512,
            "height": 512
          },
          "image": "https://ugcvideoolusturucu.com.tr/logo.png",
          "description": "Türkiye'nin lider AI destekli UGC video oluşturma platformu. E-ticaret, TikTok ve Instagram için profesyonel video içerikleri.",
          "foundingDate": "2024",
          "areaServed": {
            "@type": "Country",
            "name": "Turkey"
          },
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "TR",
            "addressLocality": "İstanbul"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "email": "destek@ugcvideoolusturucu.com.tr",
            "availableLanguage": ["Turkish"],
            "hoursAvailable": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "09:00",
              "closes": "18:00"
            }
          },
          "sameAs": [
            "https://x.com/ugcvideo_tr",
            "https://www.instagram.com/ugcvideo.tr",
            "https://www.tiktok.com/@ugcvideo.tr",
            "https://www.facebook.com/profile.php?id=61584683272356",
            "https://youtube.com/@ugcvideo_tr"
          ],
          "slogan": "AI ile Profesyonel UGC Videolar"
        };
      
      case 'article':
        return data ? {
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": data.title,
          "description": data.description,
          "image": data.image,
          "author": {
            "@type": "Person",
            "name": data.author || "UGC Video Oluşturucu",
            "url": "https://ugcvideoolusturucu.com.tr/about"
          },
          "publisher": {
            "@id": "https://ugcvideoolusturucu.com.tr/#organization"
          },
          "datePublished": data.publishedDate,
          "dateModified": data.modifiedDate || data.publishedDate,
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": data.url
          },
          "inLanguage": "tr",
          "articleSection": data.category
        } : {};
      
      case 'howto':
        return {
          "@context": "https://schema.org",
          "@type": "HowTo",
          "name": "AI ile UGC Video Nasıl Oluşturulur?",
          "description": "Yapay zeka destekli platformumuz ile profesyonel UGC videolar oluşturmanın adım adım rehberi",
          "image": "https://ugcvideoolusturucu.com.tr/logo.png",
          "totalTime": "PT5M",
          "estimatedCost": {
            "@type": "MonetaryAmount",
            "currency": "TRY",
            "value": "0"
          },
          "step": [
            {
              "@type": "HowToStep",
              "position": 1,
              "name": "Ürün Bilgisi Girin",
              "text": "E-ticaret ürününüzün adını, özelliklerini ve görselini yükleyin.",
              "image": "https://ugcvideoolusturucu.com.tr/logo.png"
            },
            {
              "@type": "HowToStep",
              "position": 2,
              "name": "AI Video Üretimi",
              "text": "Yapay zeka teknolojimiz ürününüz için UGC formatında video oluşturur.",
              "image": "https://ugcvideoolusturucu.com.tr/logo.png"
            },
            {
              "@type": "HowToStep",
              "position": 3,
              "name": "İndirin ve Paylaşın",
              "text": "Hazır videonuzu indirin ve sosyal medyada veya reklamlarda kullanın.",
              "image": "https://ugcvideoolusturucu.com.tr/logo.png"
            }
          ]
        };
      
      case 'product':
        return data || {};
      
      default:
        return {};
    }
  };

  const structuredData = getStructuredData();

  if (!structuredData || Object.keys(structuredData).length === 0) {
    return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
